// removed by extract-text-webpack-plugin
module.exports = {"react-django-template":"SearchUnitCustomControlCalendar__react-django-template___-hash--base64-5-"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/SearchUnitCustomControlCalendar/SearchUnitCustomControlCalendar.scss
 ** module id = 932
 ** module chunks = 1
 **/